import { render, staticRenderFns } from "./sendComment.vue?vue&type=template&id=4cadddb1&"
import script from "./sendComment.vue?vue&type=script&lang=js&"
export * from "./sendComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports